import type {
  WPProductConfig,
  WPProductLinkConfig,
} from "../../models/WPProductConfig";
import { configRefs } from "../constants/config";
import { DAYS_TO_MS, HOURS_TO_MS } from "../constants/time";
import { createCache } from "../createCache";

import type { ApiClientOptions } from "./typings/ApiClientOptions";
import type { ApiRequestInterceptor } from "./typings/ApiRequestInterceptor";
import { fetchRequest } from "./utils/fetchRequest";

export function makeFetchProducts(
  requestInterceptor: ApiRequestInterceptor,
  options: ApiClientOptions,
) {
  const cache = createCache<Array<WPProductConfig | WPProductLinkConfig>>({
    timeToLiveMs: 1 * HOURS_TO_MS,
    timeToEvictMs: 1 * DAYS_TO_MS,
    ...options,
  });

  return () =>
    cache("products", async () => {
      const webproeverApi = await configRefs.apis.webproever.get();
      const response = await fetchRequest<{
        products: Array<WPProductConfig | WPProductLinkConfig>;
      }>(requestInterceptor(`${webproeverApi}/produkter/`));

      return response.products.map((product) => ({
        ...product,
        vignette: `${webproeverApi}${product.vignette}`,
      }));
    });
}
